import breakpoints from "../tokens/breakpoints";
import { ThemeProperties } from "../theme.types";

export const cosikaTheme: ThemeProperties = {
  name: "cosika",
  title: "Rendu Photoréaliste COSIKA",

  assets: {
    logo: "/themes/cosika/cosika-logo-white.png",
    favicon: "/themes/cosika/favicon_cosika.png",
  },

  gradients: {
    headerBackground:
      "linear-gradient(180deg,rgba(11, 26, 18, 1) 0%,rgba(11, 26, 18, 1) 50%,rgba(30, 32, 49, 1) 100%)",
  },

  breakpoints: breakpoints,
};
